import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
    selector: 'app-animated-bg',
    standalone: true,
    template: `
        <div class="bg" aria-hidden="true">
            <svg class="svg" viewBox="0 0 1200 600" preserveAspectRatio="none">
                <defs>
                    <linearGradient id="grad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stop-color="#4F7DFF"/>
                        <stop offset="1" stop-color="#00E5A8"/>
                    </linearGradient>

                    <radialGradient id="orbA" cx="30%" cy="20%" r="60%">
                        <stop offset="0" stop-color="rgba(79,125,255,.35)"/>
                        <stop offset="1" stop-color="rgba(79,125,255,0)"/>
                    </radialGradient>
                    <radialGradient id="orbB" cx="70%" cy="70%" r="60%">
                        <stop offset="0" stop-color="rgba(0,229,168,.25)"/>
                        <stop offset="1" stop-color="rgba(0,229,168,0)"/>
                    </radialGradient>

                    <filter id="glow">
                        <feGaussianBlur stdDeviation="3.5" result="b"/>
                        <feMerge>
                            <feMergeNode in="b"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>

                <!-- soft orbs -->
                <rect x="-200" y="-200" width="700" height="700" fill="url(#orbA)">
                    <animate attributeName="x" values="-220;-190;-220" dur="10s" repeatCount="indefinite"/>
                    <animate attributeName="y" values="-210;-180;-210" dur="10s" repeatCount="indefinite"/>
                </rect>
                <rect x="700" y="120" width="650" height="650" fill="url(#orbB)">
                    <animate attributeName="x" values="720;690;720" dur="11s" repeatCount="indefinite"/>
                    <animate attributeName="y" values="140;110;140" dur="11s" repeatCount="indefinite"/>
                </rect>

                <!-- PIPELINE PATHS -->
                <g opacity="0.75" filter="url(#glow)" stroke="url(#grad)" stroke-width="3" fill="none">
                    <path id="p1" d="M120 420 C 260 360, 280 300, 380 280 S 560 260, 640 220 S 820 150, 980 170"/>
                    <path id="p2" d="M160 220 C 260 230, 320 260, 420 320 S 590 420, 700 410 S 900 380, 1040 320"
                          opacity="0.55"/>
                    <path id="p3" d="M260 520 C 380 460, 460 420, 520 380 S 650 300, 760 280 S 960 260, 1120 210"
                          opacity="0.35"/>
                </g>

                <!-- PIPELINE NODES -->
                <g filter="url(#glow)">
                    <g *ngFor="let n of nodes">
                        <circle [attr.cx]="n.x" [attr.cy]="n.y" r="7" fill="#061024" stroke="url(#grad)"
                                stroke-width="3"/>
                        <circle [attr.cx]="n.x" [attr.cy]="n.y" r="2.2" fill="rgba(255,255,255,.75)">
                            <animate attributeName="opacity" values="0;1;0.2;1;0" dur="3.2s" [attr.begin]="n.delay"
                                     repeatCount="indefinite"/>
                        </circle>
                    </g>
                </g>

                <!-- FLOW DOTS ALONG PATHS -->
                <g>
                    <circle r="4" fill="rgba(255,255,255,.75)">
                        <animateMotion dur="4.8s" repeatCount="indefinite" rotate="auto">
                            <mpath href="#p1"></mpath>
                        </animateMotion>
                        <animate attributeName="opacity" values="0;1;0.2;1;0" dur="4.8s" repeatCount="indefinite"/>
                    </circle>

                    <circle r="3.5" fill="rgba(0,229,168,.8)">
                        <animateMotion dur="5.6s" repeatCount="indefinite" rotate="auto" begin="0.6s">
                            <mpath href="#p2"></mpath>
                        </animateMotion>
                        <animate attributeName="opacity" values="0;1;0.2;1;0" dur="5.6s" begin="0.6s"
                                 repeatCount="indefinite"/>
                    </circle>

                    <circle r="3" fill="rgba(79,125,255,.85)">
                        <animateMotion dur="6.2s" repeatCount="indefinite" rotate="auto" begin="1.1s">
                            <mpath href="#p3"></mpath>
                        </animateMotion>
                        <animate attributeName="opacity" values="0;1;0.2;1;0" dur="6.2s" begin="1.1s"
                                 repeatCount="indefinite"/>
                    </circle>
                </g>

                <!-- DASHBOARD PANEL (RIGHT) -->
                <g transform="translate(720,120)" opacity="0.85" filter="url(#glow)">
                    <rect x="0" y="0" width="420" height="280" rx="26" fill="rgba(255,255,255,.03)"
                          stroke="rgba(255,255,255,.12)"/>
                    <rect x="22" y="26" width="210" height="110" rx="18" fill="rgba(255,255,255,.03)"
                          stroke="rgba(255,255,255,.10)"/>
                    <rect x="248" y="26" width="150" height="110" rx="18" fill="rgba(255,255,255,.03)"
                          stroke="rgba(255,255,255,.10)"/>

                    <!-- chart line -->
                    <path d="M34 116 L72 88 L102 96 L138 64 L170 78 L206 52"
                          stroke="url(#grad)" stroke-width="4" fill="none" stroke-linecap="round">
                        <animate attributeName="stroke-dasharray" values="0 400;180 220;0 400" dur="4.5s"
                                 repeatCount="indefinite"/>
                    </path>

                    <!-- bar chart -->
                    <g transform="translate(270,48)">
                        <rect x="0" y="52" width="16" height="40" rx="6" fill="rgba(79,125,255,.85)">
                            <animate attributeName="height" values="36;44;36" dur="2.4s" repeatCount="indefinite"/>
                            <animate attributeName="y" values="56;48;56" dur="2.4s" repeatCount="indefinite"/>
                        </rect>
                        <rect x="24" y="40" width="16" height="52" rx="6" fill="rgba(0,229,168,.75)">
                            <animate attributeName="height" values="48;58;48" dur="2.4s" begin="0.2s"
                                     repeatCount="indefinite"/>
                            <animate attributeName="y" values="44;34;44" dur="2.4s" begin="0.2s"
                                     repeatCount="indefinite"/>
                        </rect>
                        <rect x="48" y="30" width="16" height="62" rx="6" fill="rgba(56,189,248,.65)">
                            <animate attributeName="height" values="56;70;56" dur="2.4s" begin="0.4s"
                                     repeatCount="indefinite"/>
                            <animate attributeName="y" values="36;22;36" dur="2.4s" begin="0.4s"
                                     repeatCount="indefinite"/>
                        </rect>
                    </g>

                    <!-- bottom mini panels -->
                    <rect x="22" y="156" width="170" height="100" rx="18" fill="rgba(255,255,255,.03)"
                          stroke="rgba(255,255,255,.10)"/>
                    <rect x="206" y="156" width="192" height="100" rx="18" fill="rgba(255,255,255,.03)"
                          stroke="rgba(255,255,255,.10)"/>
                </g>

                <!-- vignette -->
                <rect x="0" y="0" width="1200" height="600" fill="rgba(7,11,23,.0)"/>
            </svg>
        </div>
    `,
    imports: [
        NgForOf
    ],
    styles: [`
        .bg {
            position: absolute;
            inset: 0;
            z-index: -1;
            overflow: hidden;
            pointer-events: none;
        }

        .svg {
            width: 100%;
            height: 100%;
            opacity: 0.95;
        }

        @media (prefers-reduced-motion: reduce) {
            /* stop svg SMIL motion for reduced motion users */
            .svg animate, .svg animateMotion {
                display: none;
            }
        }
    `]
})
export class AnimatedBgComponent {
    nodes = [
        { x: 120, y: 420, delay: '0s' },
        { x: 260, y: 360, delay: '0.2s' },
        { x: 380, y: 280, delay: '0.4s' },
        { x: 520, y: 260, delay: '0.6s' },
        { x: 640, y: 220, delay: '0.8s' },
        { x: 820, y: 150, delay: '1.0s' },
        { x: 980, y: 170, delay: '1.2s' },

        { x: 160, y: 220, delay: '0.1s' },
        { x: 420, y: 320, delay: '0.5s' },
        { x: 700, y: 410, delay: '0.9s' },
        { x: 1040, y: 320, delay: '1.3s' },
    ];
}
